import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './utils/api'
import 'lib-flexible/flexible.js'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

import wechat from './utils/wechat.js';
Vue.prototype.$wechat = wechat;

import until from './utils/until'
Vue.prototype.$until = until

import request from '@/utils/request'
Vue.prototype.$request = request

Vue.prototype.$api = api;
Vue.config.productionTip = false

Vue.prototype.$placeImg = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/1_1%E5%8D%A0%E4%BD%8D%E5%9B%BE%E9%95%BF.jpg'
Vue.prototype.$vip = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip.png'
// Vue.prototype.$noVip = 'https://pkusaas.oss-cn-beijing.aliyu ncs.com/miniprogram/study_center/noVip.png'
Vue.prototype.$noVip = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/opacity.png' //透明图片
Vue.prototype.$free = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/free.png'
Vue.prototype.$tuoyuPlaceImg = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/placeImg.jpg'
Vue.prototype.$tuoyuPlaceImgSmall = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/placeImgSmall.jpg'

Vue.prototype.$logoBig = 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/zhongtuo/logoBig.png'
Vue.prototype.$trainId = ['588', '587', '774', '775', '776']

Vue.directive('throttle', { 
  bind: (el, binding) => {
    let throttleTime = binding.value; // 防抖时间
    if (!throttleTime) { // 用户若不设置防抖时间，则默认2s
      throttleTime = 2000;
    }
    let cbFun;
    el.addEventListener('click', event => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  },
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
